export const specificReasonDetail = (feedback?: string): string | undefined => {
  if (!feedback) return undefined;
  const idx = feedback.indexOf(': ');
  return idx >= 0 ? feedback.slice(idx + 2) : feedback;
};

export const disqualificationRuleReason = (ruleCode?: string): { label: string; detail: string } => {
  switch (ruleCode) {
    case 'MIN_ABSTRACT_LENGTH':
      return { label: 'Abstract too short', detail: 'The nomination abstract is below the minimum length required for this award.' };
    case 'REQUIRED_FIELDS':
      return { label: 'Joint nominations not allowed', detail: 'Joint nominees were included on an award that does not allow joint nominations.' };
    case 'INELIGIBLE':
      return { label: 'Not eligible for this award', detail: 'The nominating partner does not meet any of the eligibility criteria configured for this award.' };
    default:
      return { label: 'Automated rule check', detail: 'This nomination was disqualified by an automated eligibility/quality rule during AI scrubbing.' };
  }
};
